export default __webpack_public_path__ + "static/tm-aba7eb64df1930b483cd778aebcfc569.png";